import { createRoute, lazyRouteComponent, Outlet } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';
import RequireWarehouse from 'root/RequireWarehouse';

const inventoryAdjustmentsMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  id: 'inventory-adjustments-main',
  validateSearch: z.object({
    searchFromCatalog: z.boolean().optional(),
  }),
});

const InventoryAdjustmentsRequireWarehouse = () => {
  return (
    <RequireWarehouse
      routeWithWarehouseId="/inventory-adjustments/warehouse/$warehouseId"
      routeWithoutWarehouseId="/inventory-adjustments"
    >
      <Outlet />
    </RequireWarehouse>
  );
};

const requireWarehouseRoute = createRoute({
  getParentRoute: () => inventoryAdjustmentsMainRoute,
  path: '/inventory-adjustments',
  component: InventoryAdjustmentsRequireWarehouse,
});

const inventoryAdjustmentsWarehouseWrapperRoute = createRoute({
  getParentRoute: () => requireWarehouseRoute,
  path: 'warehouse/$warehouseId',
  parseParams: z.object({ warehouseId: z.string().uuid() }).parse,
});

export const inventoryAdjustmentsRoute = createRoute({
  getParentRoute: () => inventoryAdjustmentsWarehouseWrapperRoute,
  path: '/',
  component: lazyRouteComponent(
    () => import('./InventoryAdjustmentsView/InventoryAdjustmentsView'),
  ),
  validateSearch: z.object({
    searchFromCatalog: z.boolean().optional(),
    adjustByCSVModalOpen: z.boolean().optional(),
    uploadOutboundsModalOpen: z.boolean().optional(),
    reservedItemId: z.string().optional(),
  }),
});

export const adjustInventoryRoute = createRoute({
  getParentRoute: () => inventoryAdjustmentsWarehouseWrapperRoute,
  path: '$productId',
  component: lazyRouteComponent(() => import('./AdjustInventoryView/AdjustInventoryView')),
  validateSearch: z.object({
    from: z.string().optional(),
    taskId: z.string().optional(),
    subtaskId: z.string().optional(),
    taskMetadataType: z.enum(['MOVE_ITEMS', 'COUNT_ITEMS']).optional(),
    moveItemsLocationBatchIds: z.array(z.string()).optional(),
    recommendedLocationId: z.string().optional(),
    recommendedLocationName: z.string().optional(),
    searchQuery: z.coerce.string().optional(),
  }),
  parseParams: (params) => ({
    productId: z.string().parse(params.productId),
  }),
});

export const inventoryAdjustmentsRouteTree = inventoryAdjustmentsMainRoute.addChildren({
  requireWarehouseRoute: requireWarehouseRoute.addChildren({
    inventoryAdjustmentsWarehouseWrapperRoute:
      inventoryAdjustmentsWarehouseWrapperRoute.addChildren({
        inventoryAdjustmentsRoute,
        adjustInventoryRoute,
      }),
  }),
});
